<ng-container *ngIf="collapsible; else nonCollapsibleTemplate">
    <p-accordion [(activeIndex)]="accordionActiveIndex">
        <p-accordionTab>
            <ng-template pTemplate="header">
                <div class="flex align-items-center justify-content-between w-full pr-2">
                    <div class="flex align-items-center gap-3">
                        <i class="pi pi-eye text-blue-400 text-xl"></i>
                        <div class="flex flex-column">
                            <span class="font-semibold text-lg" [ngClass]="{'mb-2': getLatestVisit()}">
                                <ng-container *ngIf="getLatestVisit(); else noVisitsTemplate">
                                    Visit Summary (Click to see all visits)
                                </ng-container>
                                <ng-template #noVisitsTemplate>
                                    <span class="text-500">No Visits Found</span>
                                </ng-template>
                            </span>
                            <div class="flex align-items-center gap-4 text-sm text-600"
                                *ngIf="getLatestVisit() as latestVisit">
                                <span class="flex align-items-center gap-1">
                                    <i class="pi pi-calendar"></i>
                                    {{ getHumanReadableDate(latestVisit.date) }}
                                </span>
                                <span class="flex align-items-center gap-1" *ngIf="latestVisit.ageString">
                                    <i class="pi pi-user"></i>
                                    {{ latestVisit.ageString }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex align-items-center gap-3 text-sm" *ngIf="getLatestVisit() as latestVisit">
                        <div *ngFor="let measurement of getSortedEyeMeasurements(latestVisit.eyeMeasurements)"
                            class="flex align-items-center justify-content-between gap-2">
                            <span [style.color]="measurement.eyeSide === Eye.LEFT ? '#9747FF' : '#FD52B9'">
                                <b>{{ measurement.eyeSide === Eye.LEFT ? "(OS)" : "(OD)" }}</b>
                            </span>
                            <p-tag [style]="{'minWidth':'6em'}" [value]="getMeasurementLabel(measurement)"
                                [severity]="getMeasurementSeverity(measurement)"></p-tag>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-container *ngTemplateOutlet="visitsContentTemplate"></ng-container>

        </p-accordionTab>
    </p-accordion>
</ng-container>

<ng-template #nonCollapsibleTemplate>
    <ng-container *ngTemplateOutlet="visitsContentTemplate"></ng-container>
</ng-template>

<ng-template #visitsContentTemplate>
    <div class="w-full flex flex-column justify-content-center align-items-center gap-3">
        <p-card *ngFor="let visit of visits;" class="w-full">
            <div class="w-full flex justify-content-between align-items-center">
                <div class="flex justify-content-between align-items-center gap-6">
                    <p><i class="pi pi-calendar"></i> {{ getHumanReadableDate(visit.date) }}</p>
                    <p><i class="pi pi-user"></i> {{ visit.ageString }}</p>
                </div>

                <p-menu #menu appendTo="body" [model]="getVisitMenuItems(visit)" [popup]="true"></p-menu>
                <p-button icon="pi pi-ellipsis-v" [text]="true" (click)="menu.toggle($event)"
                    [style]="{'color': '#6b7280'}" aria-label="Visit options">
                </p-button>
            </div>

            <p-divider styleClass="mt-2 mb-0" />

            <div class="w-full flex flex-column justify-content-center align-items-center text-center">
                <div *ngFor="let measurement of getSortedEyeMeasurements(visit.eyeMeasurements)"
                    class="flex gap-6 flex-row justify-content-center align-items-center">
                    <p [style.color]="measurement.eyeSide === Eye.LEFT ? '#9747FF' : '#FD52B9'">
                        <b>{{ measurement.eyeSide === Eye.LEFT ? "(OS)" : "(OD)" }}</b>
                    </p>

                    <p-tag [style]="{'minWidth':'8em'}" [value]="getMeasurementLabel(measurement)"
                        [severity]="getMeasurementSeverity(measurement)"></p-tag>

                    <p><b>Sphere</b><br>{{ measurement.sphere !== undefined && measurement.sphere !== null ?
                        (measurement.sphere | signedNumber) : "N/A" }}</p>
                    <p><b>Cylinder</b><br>{{ measurement.cylinder !== undefined && measurement.cylinder !== null ?
                        (measurement.cylinder | signedNumber) : "N/A" }}
                    </p>
                    <p><b>Axis</b><br>{{ measurement.axis !== undefined && measurement.axis !== null ? (measurement.axis
                        + "°") : "N/A"}}</p>
                    <p><b>Axial Length</b><br>{{ measurement.axialLength !== undefined && measurement.axialLength !==
                        null ? (measurement.axialLength + " mm") : "N/A"
                        }} </p>
                    <p><b>K Value</b><br>{{ measurement.kValue !== undefined && measurement.kValue !== null ?
                        (measurement.kValue + " mm") : "N/A" }}</p>
                </div>

            </div>

        </p-card>
    </div>
</ng-template>